module.exports = __webpack_public_path__ + "assets/codemirror.393e5ae9.svg";